// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"TroRegularPrice_sectionWrapper__oOpUT","ifNumberOfPieces":"TroRegularPrice_ifNumberOfPieces__FDDfD","radioButton":"TroRegularPrice_radioButton__P81Rs"};